import { render, staticRenderFns } from "./DisplayJdrModal.vue?vue&type=template&id=6317c6de&scoped=true"
import script from "./DisplayJdrModal.vue?vue&type=script&lang=js"
export * from "./DisplayJdrModal.vue?vue&type=script&lang=js"
import style0 from "./DisplayJdrModal.vue?vue&type=style&index=0&id=6317c6de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6317c6de",
  null
  
)

export default component.exports